import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { TruncatingBadgeWebElement } from './TruncatingBadgeWebElement';
export { TruncatingBadgeWebElement };

/**
 * Retrieve an instance of [TruncatingBadgeWebElement](../classes/TruncatingBadgeWebElement.html).
 * @example
 * ```javascript
 * import { findTruncatingBadge } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findTruncatingBadge(driver, By.id('my-oj-c-truncating-badge'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findTruncatingBadge(
  driver: DriverLike,
  by: By
): Promise<TruncatingBadgeWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type TruncatingBadgeWebElement
  if (!(webEl instanceof TruncatingBadgeWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'TruncatingBadgeWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findTruncatingBadge(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${TruncatingBadgeWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-truncating-badge', TruncatingBadgeWebElement);
